import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  date: string;
  views: number;
  tags: string[];
  variant?: 'featured' | 'default';
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  category,
  categorySlug,
  imageUrl,
  date,
  views,
  tags,
  variant = 'default',
}: ArticleCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return String(v);
  };

  if (variant === 'featured') {
    return (
      <article className="bg-foreground-900 rounded-lg overflow-hidden group cursor-pointer h-full flex flex-col">
        <div className="relative h-56 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 51在线吃瓜`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 to-transparent"></div>
          <div className="absolute top-3 left-3 flex flex-wrap gap-2">
            <span className="px-2.5 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              {category}
            </span>
          </div>
        </div>
        <div className="p-5 flex-1 flex flex-col justify-between">
          <div>
            <h3 className="text-background-50 text-lg font-medium leading-snug mb-2 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
              {title}
            </h3>
            <p className="text-background-400 text-sm leading-relaxed line-clamp-2">
              {excerpt}
            </p>
          </div>
          <div className="flex items-center justify-between mt-4 text-xs text-background-500">
            <span>{date}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(views)}
            </span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer h-full flex flex-col">
      <div className="relative h-44 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 51在线吃瓜`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-2">
          <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            {category}
          </span>
        </div>
      </div>
      <div className="p-4 flex-1 flex flex-col justify-between">
        <div>
          <h3 className="text-foreground-950 text-base font-medium leading-snug mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
            {title}
          </h3>
          <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
            {excerpt}
          </p>
        </div>
        <div className="flex items-center justify-between mt-3 text-xs text-foreground-500">
          <span>{date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(views)}
          </span>
        </div>
      </div>
    </article>
  );
}